import { create } from 'zustand';

const uid = () => Math.random().toString(36).substring(2, 11);

/**
 * Global upload queue store.
 * Items flow through states: queued → uploading → processing → ready → publishing → done | error
 */
export const useUploadStore = create((set, get) => ({
  items: [],   // UploadItem[]
  isOpen: false,

  /** Add one or more File objects to the queue. Returns the local IDs. */
  addFiles: (files) => {
    const newItems = Array.from(files).map((file) => ({
      localId: uid(),
      file,
      fileName: file.name,
      fileSize: file.size,
      mediaType: null,       // 'audio' | 'video' — detected during upload
      duration: 0,
      episodeId: null,       // assigned after backend draft is created
      // publish form fields
      title: file.name.replace(/\.[^/.]+$/, ''),
      description: '',
      isFree: false,
      scheduledAt: '',       // ISO string or empty
      thumbnailFile: null,
      thumbnailPreview: null,
      tosAccepted: false,
      // state machine
      state: 'queued',       // queued|uploading|processing|ready|publishing|done|error
      progress: 0,
      processingLabel: null, // custom label shown during processing (e.g. transcoding message)
      error: null,
    }));
    set((s) => ({ items: [...s.items, ...newItems], isOpen: true }));
    return newItems.map((i) => i.localId);
  },

  updateItem: (localId, changes) =>
    set((s) => ({
      items: s.items.map((i) => (i.localId === localId ? { ...i, ...changes } : i)),
    })),

  removeItem: (localId) =>
    set((s) => ({ items: s.items.filter((i) => i.localId !== localId) })),

  setOpen: (open) => set({ isOpen: open }),
}));
